import I18n from 'APP/I18n'
import type { FamilyMember } from 'APP/Store/Family/types'

export const checkDuplicateFamilyMembersHelper = (
  email: string,
  familyMembers: Record<string, FamilyMember>
): boolean | string => {
  const lowerCaseEmail = email?.toLowerCase().trim()
  let isEmailUnique = true
  Object.keys(familyMembers).forEach((key) => {
    if (familyMembers[key]?.email?.toLowerCase() === lowerCaseEmail) {
      isEmailUnique = false
      return
    }
  })
  if (!isEmailUnique) return I18n.t('FamilyScreen.addAdult.error.alreadyFamilyMember')
  return isEmailUnique
}
